const defaultProps = () => ({ style: { minWidth: 100 } });

export const COLUMNS = [
  {
    name: 'cashinDate',
    label: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'cashinDate',
    label: 'Date',
    options: {
      display: true,
      sort: true,
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'invoice',
    label: 'Invoice',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'companyName',
    label: 'Company Name',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'candidateName',
    label: 'Candidate Name',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'startDate',
    label: 'Start Date',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'guarantee',
    label: 'Guarantee',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'cashin',
    label: 'Cash In',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'commission',
    label: 'Commission',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'cashinDate',
  direction: 'asc'
};
